import { useMemo } from 'react';
import { tokenize } from '../utils/prism';

// Jetons Prism → éléments React (classes `token …`, couleurs --ds-syntax-*)
export function renderTokens(tokens, prefix = 't') {
  return tokens.map((token, i) => {
    if (typeof token === 'string') return token;
    const alias = Array.isArray(token.alias) ? token.alias.join(' ') : token.alias || '';
    const content = Array.isArray(token.content)
      ? renderTokens(token.content, `${prefix}-${i}`)
      : typeof token.content === 'string'
        ? token.content
        : renderTokens([token.content], `${prefix}-${i}`);
    return (
      <span key={`${prefix}-${i}`} className={`token ${token.type} ${alias}`.trim()}>
        {content}
      </span>
    );
  });
}

/** Contenu d'un <code> coloré (texte brut si le langage n'est pas pris en charge). */
export function HighlightedCode({ code, language }) {
  const tokens = useMemo(() => tokenize(code, language), [code, language]);
  return (
    <code className={language ? `language-${language}` : undefined}>
      {tokens ? renderTokens(tokens) : code}
    </code>
  );
}
